module.exports = __webpack_public_path__ + "static/img/28.530b9f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/28.png
// module id = UWHC
// module chunks = 1